import React from 'react';

const JotFormEmbed = ({ emailAddress, distributorCode ,distributorName}) => {

  const formBaseURL = "https://form.jotform.com/243512496034454";
  const params = new URLSearchParams({
    emailAddress: emailAddress || "",   
    distributorCode: distributorCode || "",
    distributorName: distributorName || ""
  });

  const formURL = `${formBaseURL}?${params.toString()}`;

  return (
    <div>
      <iframe
        title="Jotform"
        src={formURL}
        width="100%"
        className="jotform-iframe"
        frameBorder="0"
        scrolling="no"
      ></iframe>

      <style jsx>{`
        /* Default iframe height (for desktop) */
        .jotform-iframe {
          height: 2000px;
        }

     
        @media (max-width: 768px) {
          .jotform-iframe {
            height: 3000px;
          }
        }
      `}</style>
    </div>
  );
};

export default JotFormEmbed;
